export default __webpack_public_path__ + "static/media/bgwork.62612edb.jpg";